import { render, staticRenderFns } from "./TableSettingsDialog.vue?vue&type=template&id=619c4798&scoped=true"
import script from "./TableSettingsDialog.vue?vue&type=script&lang=js"
export * from "./TableSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./TableSettingsDialog.vue?vue&type=style&index=0&id=619c4798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c4798",
  null
  
)

export default component.exports